export default "__VITE_ASSET__Ctq9VDOI__"